import { useQueryParams } from '@calendly/hooks'
import { buildQuery } from '@calendly/http-tools'
import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

export const useManagedEventTypeQueryParams = () => {
  const history = useHistory()
  const queryParams = useQueryParams()
  const {
    filter_term: currentFilterTerm,
    sort_field: currentSortField,
    sort_order: currentSortOrder,
    page: currentPage
  } = queryParams

  const updateQueryParams = useCallback(({ filterTerm, sortField, sortOrder, page }) => {
    let searchQuery = queryParams

    // Search field param management
    if (filterTerm !== currentFilterTerm) {
      if (filterTerm) {
        searchQuery = { ...searchQuery, filter_term: filterTerm }
      } else {
        delete searchQuery.filter_term
      }

      if (queryParams.page && Number(queryParams.page) > 1) {
        delete searchQuery.page // reset page when on first search input (default page 1)
      }
    }

    // Table sorting params management
    if (sortField && sortOrder) {
      searchQuery = { ...searchQuery, sort_field: sortField, sort_order: sortOrder }
      if (queryParams.page && Number(queryParams.page) > 1) {
        delete searchQuery.page // reset page when sorting (default page 1)
      }
    }

    // Table pagination param management
    if (page && Number(page) !== 1) {
      searchQuery = { ...searchQuery, page } // overwrite page with page argument
    } else if (Number(page) === 1) {
      delete searchQuery.page // remove page if page argument is eql 1
    }

    history.push({ search: buildQuery(searchQuery) })
  }, [history, currentFilterTerm, queryParams])

  return [{
    filterTerm: currentFilterTerm,
    sortField: currentSortField,
    sortOrder: currentSortOrder,
    page: currentPage,
  }, updateQueryParams]
}
